import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { openRemoteModalWrapper } from 'src/components/pages/legacy/components/open-legacy-remote-modal-link';
import { useAuthorization } from 'src/hooks/use-authorization';
import { useUrls } from 'src/hooks/use-urls';

export const useTaskModal = () => {
  const { getTaskEditUrl, getAddTaskUrl } = useUrls();
  const { getFeatureFlag } = useAuthorization();
  const showInlineForm =
    getFeatureFlag('ux-redesign-v2.5') && getFeatureFlag('inline-forms-redesign');
  const history = useHistory();

  const getTaskModalUrl = useCallback(
    (taskId: number) => {
      return getTaskEditUrl({ taskId, options: { includeHost: !showInlineForm } });
    },
    [showInlineForm, getTaskEditUrl],
  );

  const showEditTaskModal = useCallback(
    (taskId: number) => {
      const taskModalUrl = getTaskModalUrl(taskId);

      if (showInlineForm) {
        history.push(taskModalUrl);
      } else {
        openRemoteModalWrapper(taskModalUrl);
      }
    },
    [showInlineForm, getTaskModalUrl, history],
  );

  const showAddTaskModal = useCallback(
    ({ contactId }: { contactId?: number } = {}) => {
      const taskModalUrl = getAddTaskUrl({ contactId });

      if (showInlineForm) {
        history.push(taskModalUrl);
      } else {
        openRemoteModalWrapper(taskModalUrl);
      }
    },
    [getAddTaskUrl, showInlineForm, history],
  );

  return { showEditTaskModal, getTaskModalUrl, showAddTaskModal };
};
